import DeleteAccount from "./settings/DeleteAccount";
import MyToastmasters from "./settings/MyToastmasters";
import PasswordReset from "./settings/PasswordReset";
import UserDetails from "./settings/UserDetails";
import { useContext, useEffect, useState } from "react"
import { useSelector } from "react-redux";
import { ProfileContext } from "pages/Profile";
import { Row, Col } from "react-bootstrap";
import { isOfficer } from "utils/acl";
import { getLegacyInstanceRegistrationStatus, registerLegacyInstanceInController } from "services/instanceRegistration";

export default function Settings() {

  const { user: authUser } = useSelector(x => x.auth)
  const { profile } = useContext(ProfileContext)
  const [registering, setRegistering] = useState(false)
  const [registerMessage, setRegisterMessage] = useState('')
  const [instanceRegistered, setInstanceRegistered] = useState(false)
  const [registrationStatusReady, setRegistrationStatusReady] = useState(false)

  const canRegister = isOfficer(authUser?.user?.acl) || Boolean(authUser?.user?.isWebmaster)

  useEffect(() => {
    let cancelled = false
    if (!canRegister) {
      setRegistrationStatusReady(true)
      return undefined
    }

    const loadRegistrationState = async () => {
      try {
        const result = await getLegacyInstanceRegistrationStatus()
        if (!cancelled) {
          setInstanceRegistered(Boolean(result?.registered))
          setRegistrationStatusReady(true)
        }
      } catch {
        if (!cancelled) {
          setInstanceRegistered(false)
          setRegistrationStatusReady(true)
        }
      }
    }

    loadRegistrationState()
    return () => {
      cancelled = true
    }
  }, [canRegister])

  const registerInstance = async () => {
    try {
      setRegistering(true)
      setRegisterMessage('')

      const result = await registerLegacyInstanceInController()
      setRegisterMessage(result.message)
      setInstanceRegistered(true)
      setRegistrationStatusReady(true)
    } catch (error) {
      setRegisterMessage(error.message || 'Registration failed')
    } finally {
      setRegistering(false)
    }
  }

  return (
    <Row className="g-3 settings-grid">
      <Col xs={12} lg={5} xxl={4} className="settings-grid-item">
        <div className="d-flex flex-column gap-3 w-100">
          <UserDetails profile={profile.profile} />
          {canRegister && registrationStatusReady && !instanceRegistered && (
            <div className="settings-action-card d-flex flex-column gap-2">
              <strong>Instance Registration</strong>
              <p className="mb-0 small text-muted">Register this instance in tm-controller.</p>
              <button type="button" className="btn btn-primary" onClick={registerInstance} disabled={registering}>
                {registering ? 'Registering...' : 'Register this instance in Controller'}
              </button>
              {registerMessage && <div className="small text-muted">{registerMessage}</div>}
            </div>
          )}
        </div>
      </Col>

      <Col xs={12} lg={3} xxl={4} className="settings-grid-item">
        <div className="d-flex flex-column gap-3 w-100">
          <MyToastmasters />
        </div>
      </Col>

      <Col xs={12} lg={4} xxl={4} className="settings-grid-item">
        <div className="d-flex flex-column gap-3 w-100">
          <PasswordReset profile={profile.profile} />
          {
            ((authUser.user.acl === 'Officer' || authUser.user._id === profile._id) && profile.hidden !== true) &&
            <DeleteAccount profile={profile.profile} />
          }
        </div>
      </Col>
    </Row>
  )
}